import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../utils/supabase";
import AuthLayout from "../components/AuthLayout";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const { error: authError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (authError) {
      setError(authError.message);
      setLoading(false);
    } else {
      navigate("/");
    }
  };

  return (
    <AuthLayout>
      <h1
        className="text-text-primary text-[28px] mb-2"
        style={{ fontWeight: 700 }}
      >
        Welcome Back
      </h1>
      <p className="text-[#b0b0b0] text-[13px] mb-8" style={{ fontWeight: 500 }}>
        Log in to your Pixrd account
      </p>

      <form onSubmit={handleLogin}>
        <label
          className="block text-[#888] text-[10px] uppercase tracking-[3px] mb-2"
          style={{ fontWeight: 600 }}
        >
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full bg-[#0a0a0a] border border-[#333] text-white text-[14px] px-4 py-3 mb-5 outline-none transition-colors focus:border-[#FF6B00]"
          style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}
        />

        <label
          className="block text-[#888] text-[10px] uppercase tracking-[3px] mb-2"
          style={{ fontWeight: 600 }}
        >
          Password
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={6}
          className="w-full bg-[#0a0a0a] border border-[#333] text-white text-[14px] px-4 py-3 mb-6 outline-none transition-colors focus:border-[#FF6B00]"
          style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}
        />

        {error && (
          <p
            className="text-[#f87171] text-[12px] mb-4"
            style={{ fontWeight: 500 }}
          >
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full text-[11px] uppercase tracking-[3px] py-3 transition-all duration-200"
          style={{
            backgroundColor: "#FF6B00",
            color: "#000",
            fontWeight: 700,
            opacity: loading ? 0.6 : 1,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Logging in..." : "Log In"}
        </button>
      </form>

      <div className="border-t border-[#222] my-8"></div>

      <p
        className="text-[#888] text-[12px] text-center"
        style={{ fontWeight: 500 }}
      >
        Don't have an account?{" "}
        <Link
          to="/signup"
          className="text-[#b0b0b0] hover:text-[#FF6B00] transition-colors"
          style={{ fontWeight: 600 }}
        >
          Sign Up
        </Link>
      </p>
    </AuthLayout>
  );
}

export default LoginPage;
